setTimeout(function () {
  document.querySelector(".header").classList.add("hide-monkey");
}, 10000);

window.addEventListener("scroll", () => {
  // Calculate rotation angle based on scroll position
  const rotation = window.scrollY % 360;

  // // Apply rotation to all small-star elements
  // document.querySelectorAll(".small-star").forEach((star) => {
  //   star.style.transform = `rotate(${rotation}deg)`;
  // });

  // Apply rotation to all big-star elements
  document.querySelectorAll(".big-star").forEach((star) => {
    star.style.transform = `rotate(${rotation}deg)`;
  });
});
